import { combineReducers } from 'redux';
import User from './user';
import Auth from './auth';
import Session from './session';
import Settings from './settings';

const rootReducer = combineReducers({
  user: User,
  auth: Auth,
  settings: Settings,
  session: Session
});

export default rootReducer;